import { HttpResponse } from '@angular/common/http';
import { Component, inject, input } from '@angular/core';
import {
	ApiPaginatedResponse,
	ApiRequestOrdering,
	ApiRequestPagination,
	DataExportFormatEnum,
	VehicleRoadWorthyCheckSearchDto,
	VehicleRoadWorthyChecksFilters,
	ModulesEnum,
	VehicleRoadWorthyChecksStatsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { FiltersConfig } from '../../../../shared/models/filters-config';
import { ListStrategy } from '../../../../shared/models/list-strategy';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { VehicleRoadWorthyChecksListItemMenuComponent } from '../components/vehicle-road-worthy-checks-list-item-menu/vehicle-road-worthy-checks-list-item-menu.component';
import { mapDtoToModelVehicleRoadWorthyChecks } from '../mappers/search-dto-to-model.mapper';
import { VehicleRoadWorthyChecksSectionItemComponent } from '../sections/vehicle-road-worthy-checks-section-item/vehicle-road-worthy-checks-section-item.component';
import { VehicleRoadWorthyChecksService } from '../vehicle-road-worthy-checks.service';

import { getVehicleRoadWorthyCheckFilters } from './vehicle-road-worthy-check-filters.config';

@Component({
	selector: 'app-vehicle-road-tax-selected-item',
	imports: [VehicleRoadWorthyChecksSectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-vehicle-road-worthy-checks-section-item
			[plain]="plain()"
			[item]="item()" />
	`,
})
class VehicleRoadWorthyCheckListItemComponent {
	item = input<SelectItem<VehicleRoadWorthyCheckSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleRoadWorthyCheckListStrategy implements ListStrategy<
	VehicleRoadWorthyChecksFilters,
	VehicleRoadWorthyCheckSearchDto,
	VehicleRoadWorthyChecksStatsDto
> {
	module = ModulesEnum.VEHICLE_ROAD_WORTHY_CHECKS;
	#service = inject(VehicleRoadWorthyChecksService);
	component: any = VehicleRoadWorthyCheckListItemComponent;
	componentMenu: any = VehicleRoadWorthyChecksListItemMenuComponent;
	ordering: ApiRequestOrdering = {
		columnName: `vehicle_road_worthy_check.id`,
		direction: 'DESC',
	};

	mapDtoToModel(
		vehicleRoadWorthyChecks: VehicleRoadWorthyCheckSearchDto[],
	): SelectItem<VehicleRoadWorthyCheckSearchDto>[] {
		return mapDtoToModelVehicleRoadWorthyChecks(vehicleRoadWorthyChecks);
	}
	getStats() {
		return this.#service.getStats();
	}

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: VehicleRoadWorthyChecksFilters,
		page: number,
		ordering: ApiRequestOrdering,
	): Observable<ApiPaginatedResponse<VehicleRoadWorthyCheckSearchDto[]>> {
		return this.#service.getSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
			ordering,
		);
	}

	exportList(
		format: DataExportFormatEnum,
		options: object,
		searchQueryIds: number[],
		searchFilters?: VehicleRoadWorthyChecksFilters,
		searchQuery?: string,
		pagination?: ApiRequestPagination,
		ordering?: ApiRequestOrdering,
	): Observable<HttpResponse<Blob>> {
		return this.#service.exportList(
			searchFilters,
			searchQuery,
			searchQueryIds,
			pagination,
			ordering,
			format,
			options,
		);
	}

	clearFilters() {
		this.#service.resetVehicleRoadWorthyChecksFilters();
	}

	getFiltersConfig(): FiltersConfig[] {
		return getVehicleRoadWorthyCheckFilters();
	}

	filtersObject: VehicleRoadWorthyChecksFilters = this.#service.filtersObject;

	filterSubjects: any = this.#service.vehicleRoadWorthyChecksFilters;
}
